/// <amd-module name="Artifacts/Root/components/InternalLink" />
import { CustomerIntelligenceHelper } from "Artifacts/Root/Helpers/CustomerIntelligenceHelper";
import { isAbsoluteUrl, isSafeProtocol } from "Artifacts/Root/Helpers/UrlHelper";
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";
import { ILinkProps, Link } from "VSSUI/Link";

export interface InternalLinkProps extends ILinkProps {
  pageContext: IVssPageContext;
  ciFeature: string;
  ciContext?: string;
  onClick?: (
    ev:
      | React.MouseEvent<HTMLAnchorElement | HTMLElement | HTMLButtonElement>
      | React.KeyboardEvent<HTMLAnchorElement | HTMLElement | HTMLButtonElement>,
  ) => void;
  linkAriaLabel?: string;
}

export class InternalLink extends React.PureComponent<InternalLinkProps> {
  public render(): JSX.Element {
    // decode so query parameters are handled properly
    const href = decodeURIComponent(this.props.href || "");

    // data, javascript, vbscript will be removed. file is safe protocol but we want
    // to remove that as well
    if (isAbsoluteUrl(href) && !isSafeProtocol(href)) {
      return <div>{href}</div>;
    }

    return (
      <Link
        underline
        ariaLabel={this.props.linkAriaLabel}
        {...this.props}
        href={href}
        onClick={(ev) => this._onClick(ev)}
      >
        {this.props.children}
      </Link>
    );
  }

  private _onClick(
    ev: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>,
  ): void {
    CustomerIntelligenceHelper.publishEvent(this.props.pageContext, this.props.ciFeature, {
      URL: this.props.href,
      context: this.props.ciContext,
      title: this.props.title,
    });

    if (this.props.onClick) {
      this.props.onClick(ev);
    }
  }
}
